import type { DailyStats } from "@/types/statistics";

export type DailyStatsWire = Omit<
  DailyStats,
  "profit_capital_percent" | "profit_usdt" | "trades_count"
> & {
  profit_usdt?: number | string | null;
  profit_capital_percent?: number | string | null;
  profit_percent?: number | string | null;
  trades_count?: number | string | null;
};

const toNumber = (value: number | string | null | undefined): number | null => {
  if (value === null || value === undefined || value === "") return null;
  const numeric = Number(value);
  return Number.isFinite(numeric) ? numeric : null;
};

export const normalizeDailyStats = (rows: DailyStatsWire[]): DailyStats[] => {
  return rows.map((row) => ({
    ...row,
    profit_usdt: toNumber(row.profit_usdt) ?? 0,
    profit_capital_percent:
      toNumber(row.profit_capital_percent) ?? toNumber(row.profit_percent) ?? 0,
    trades_count: toNumber(row.trades_count) ?? 0,
  }));
};
